// extracted by mini-css-extract-plugin
module.exports =  {"Readmore":"Readmore__GH9dK"};